"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomValues = void 0;
var util_locate_window_1 = require("@aws-sdk/util-locate-window");
/**
 * @implements {IRandomValues}
 */
function randomValues(byteLength) {
    return new Promise(function (resolve) {
        var randomBytes = new Uint8Array(byteLength);
        util_locate_window_1.locateWindow().msCrypto.getRandomValues(randomBytes);
        resolve(randomBytes);
    });
}
exports.randomValues = randomValues;
//# sourceMappingURL=ie11RandomValues.js.map